<h1 mat-dialog-title class="aza-pa-dialog-title">{{data.title}}</h1>

<div mat-dialog-content class="aza-pa-dialog-content">
    <mat-form-field>
        <mat-label>{{data.label}}</mat-label>
        <input [(ngModel)]="value" matInput />
    </mat-form-field>
</div>

<div mat-dialog-actions class="aza-pa-dialog-actions">
    <button mat-raised-button (click)="onClose()">{{ 'CLOSE' | translate }}</button>
    <button mat-raised-button color="primary" (click)="onOK()">{{ 'OK' | translate }}</button>
</div>
